import {AbstractWithBlank} from '../../../question-data-model/Question/Blank/abstract-with-blank.store';
import {BlankItemInstance} from '../../../question-data-model/Question/Blank/blank-item.store';
import {defaultEditorValue} from '../../../question-data-model/SlateObj/slate-editor.store';

export const AdminAbstractBlanks = AbstractWithBlank.actions((self) => ({
  addBlank(blank: any) {
    const { blankId, atIndex, key } = blank;
    self.blanks.splice(atIndex, 0, { key, id: blankId });
  },
  setTitle(title: string) {
    self.title = title;
  },
  removeBlank(blank: BlankItemInstance) {
    self.blanks.remove(blank);
  },
  setEditorValue(value: any) {
    self.editorValue = JSON.stringify(value);
  },
})).views((self) => ({
  get range() {
    return self.blanks.length;
  },
  getEditorValue() {
    return JSON.parse(self.editorValue);
  },
  get isCompleted() {
    const editorHasValue = self.editorValue !== defaultEditorValue;
    const hasAtleastOneBlank = self.blanks.length > 0;
    return editorHasValue && hasAtleastOneBlank;
  },
  get isDirty() {
    const editorValueTouched = self.editorValue !== defaultEditorValue;
    const hasAtleastOneBlank = self.blanks.length > 0;
    return editorValueTouched || hasAtleastOneBlank;
  },
}));

